const formatDate = (value) => {
  const parts = String(value || '').split('-');
  return parts.length === 3 ? parts.reverse().join('/') : value;
};

export const getCalendarCreationError = (status, data) => {
  // Keep compatibility with the backend response before the explicit code existed.
  const legacyBlock = !data?.code && Array.isArray(data?.errors?.messages) &&
    data?.message === 'No se puede crear el calendario porque existen calendarios abiertos fuera del período permitido.';
  if (status !== 409 || (data?.code !== 'STALE_OPEN_CALENDARS' && !legacyBlock)) {
    return null;
  }

  const details = data.code === 'STALE_OPEN_CALENDARS'
    ? [
      'Hay calendarios abiertos en esta estación que finalizaron más de un mes antes del inicio del calendario que querés crear.',
      ...(data.calendars || []).map((calendar) =>
        `Posición ${calendar.position_name || calendar.position}: ${formatDate(calendar.start_date)} al ${formatDate(calendar.end_date)}.`),
      ...(data.cutoff_date ? [`Deben cerrarse los calendarios con fecha de fin anterior al ${formatDate(data.cutoff_date)}.`] : []),
    ]
    : data.errors.messages.filter(Boolean);

  return {
    title: 'No se puede crear el calendario',
    detail: [...details, 'Cerrá los períodos indicados y volvé a intentar.'].join('\n'),
    meta: data,
    status,
    severity: 'warning',
    blocksCalendarCreation: true,
  };
};
